<template>
  <Can action="view" subject="billing">
    <div data-component-group="billing-dialog" data-component="edit">
      <dialog-edit
        :to="`/billing/${activeAccount?.id}`"
        :title="`${$t('billing_account')} ${activeAccount.id}`"
        icon="credit_card"
        :is-on="true"
        is-fullscreen
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-billing-edit
            :item="activeAccount"
            :is-loading="isLoadingAccount || isEditingAccount"
            :is-on="true"
            :on-cancel="onCancel"
            :on-submit="canUpdateBilling ? updateAccount : undefined"
          />
        </template>
      </dialog-edit>
    </div>
  </Can>
</template>

<script>
  import { isObj } from '@/utils';
  import fetchIfNotInStore from '@/mixins/fetchIfNotInStore';

  export default {
    emits: ['saved'],
    mixins: [fetchIfNotInStore],
    data() {
      return {
        isEditingAccount: false,
        isLoadingAccount: false,
      };
    },
    async created() {
      this.isLoadingAccount = true;
      try {
        const account = await this.fetchIfNotInStore(
          parseInt(this.$route.params.id),
          'billing',
          'items',
          'getItem',
        );
        await this.$store.dispatch('billing/setActiveItem', account);
      } catch (err) {
        this.onCancel();
      } finally {
        this.isLoadingAccount = false;
      }
    },
    computed: {
      activeAccount() {
        return this.$store.getters['billing/activeItem'];
      },
      canUpdateBilling() {
        return this.$ability.can('update', 'billing');
      },
    },
    methods: {
      async fetchSingleItem(id) {
        await this.$store.dispatch('billing/getItem', { id });
        return this.$store.getters['billing/activeItem'];
      },
      onCancel() {
        this.$router.push({ name: 'billing', query: this.$route.query });
      },
      updateAccount(item) {
        const nextItem = {
          ...item,
          id: this.activeAccount.id,
        };

        if (isObj(this.activeAccount.conflict)) {
          nextItem.resolve = 1;
        }

        this.isEditingAccount = true;

        return this.$store
          .dispatch('billing/update', nextItem)
          .then(() => {
            this.$emit('saved');
            this.$router.push({ name: 'billing', query: this.$route.query });
          })
          .catch(() => {
            return Promise.reject();
          })
          .finally(() => {
            this.isEditingAccount = false;
          });
      },
    },
  };
</script>
